import React, { useEffect, useState } from 'react';
import { MenuIcon, XIcon, PhoneIcon, MailIcon } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';
export function Navbar() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 10);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  const navLinks = [{
    name: 'Marketing',
    href: '#marketing'
  }, {
    name: 'Design',
    href: '#design'
  }, {
    name: 'CRM',
    href: '#crm'
  }, {
    name: 'Dev',
    href: '#dev'
  }, {
    name: 'Company',
    href: '#company'
  }, {
    name: 'Resources',
    href: '#resources'
  }];
  return <header className={`sticky top-0 z-40 w-full transition-all duration-300 ${isScrolled ? 'bg-white shadow-md py-3' : 'bg-white py-5'}`} data-id="element-186">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-187">
        <div className="flex justify-between items-center" data-id="element-188">
          {/* Logo */}
          <div className="flex items-center" data-id="element-189">
            <a href="#" className="text-3xl font-extrabold tracking-tighter flex items-center" data-id="element-190">
              <span className="text-gray-900" data-id="element-191">ad</span>
              <span className="text-red-600" data-id="element-192">ROI</span>
            </a>
          </div>

          {/* Desktop Nav */}
          <nav className="hidden md:flex items-center space-x-8" data-id="element-193">
            {navLinks.map(link => <a key={link.name} href={link.href} className="text-sm font-medium text-gray-600 hover:text-red-600 transition-colors" data-id="element-194">
                {link.name}
              </a>)}
          </nav>

          {/* Desktop CTA */}
          <div className="hidden md:flex items-center space-x-4" data-id="element-195">
            <a href="tel:17022134801" className="text-gray-600 hover:text-red-600 transition-colors flex items-center text-sm font-medium" data-id="element-196">
              <PhoneIcon className="h-4 w-4 mr-2" data-id="element-197" />
              (702) 213-4801
            </a>
            <button className="bg-red-600 hover:bg-red-700 text-white px-6 py-2.5 rounded-md font-semibold text-sm transition-colors shadow-sm hover:shadow-md" data-id="element-198">
              CONTACT US
            </button>
          </div>

          {/* Mobile Menu Button */}
          <div className="md:hidden flex items-center" data-id="element-199">
            <button onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)} className="text-gray-600 hover:text-gray-900 focus:outline-none" aria-label="Toggle menu" data-id="element-200">
              {isMobileMenuOpen ? <XIcon className="h-6 w-6" data-id="element-201" /> : <MenuIcon className="h-6 w-6" data-id="element-202" />}
            </button>
          </div>
        </div>
      </div>

      {/* Mobile Menu */}
      <AnimatePresence data-id="element-203">
        {isMobileMenuOpen && <motion.div initial={{
        opacity: 0,
        height: 0
      }} animate={{
        opacity: 1,
        height: 'auto'
      }} exit={{
        opacity: 0,
        height: 0
      }} className="md:hidden bg-white border-t border-gray-100 overflow-hidden" data-id="element-204">
            <div className="px-4 pt-2 pb-6 space-y-1 shadow-lg" data-id="element-205">
              {navLinks.map(link => <a key={link.name} href={link.href} className="block px-3 py-3 text-base font-medium text-gray-900 hover:bg-gray-50 hover:text-red-600 rounded-md" onClick={() => setIsMobileMenuOpen(false)} data-id="element-206">
                  {link.name}
                </a>)}
              <div className="pt-4 mt-4 border-t border-gray-100 flex flex-col space-y-4" data-id="element-207">
                <a href="tel:17022134801" className="flex items-center px-3 text-base font-medium text-gray-600" data-id="element-208">
                  <PhoneIcon className="h-5 w-5 mr-3 text-gray-400" data-id="element-209" />
                  (702) 213-4801
                </a>
                <a href="mailto:Results@GetAdROI.com" className="flex items-center px-3 text-base font-medium text-gray-600" data-id="element-210">
                  <MailIcon className="h-5 w-5 mr-3 text-gray-400" data-id="element-211" />
                  Results@GetAdROI.com
                </a>
                <button className="w-full bg-red-600 hover:bg-red-700 text-white px-4 py-3 rounded-md font-semibold text-base transition-colors mt-2" data-id="element-212">
                  CONTACT US
                </button>
              </div>
            </div>
          </motion.div>}
      </AnimatePresence>
    </header>;
}